import React, { useState } from 'react';
import { TextField, Button, Typography, Stack } from '@mui/material';
import { validatePassword } from './passwordValidator';
import { resetPasswordAPI } from "../src/service/ResetPasswordService";

const ResetPasswordForm = ({ token }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const validation = validatePassword(newPassword);
  const allValid = Object.values(validation).every(Boolean);

  const handleReset = async () => {
    setResetMessage("");
    setErrorMessage("");

    if (!newPassword || !confirmPassword) {
      setErrorMessage('Please fill in both fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    if (!allValid) {
      setErrorMessage('Password does not meet the required rules.');
      return;
    }    

    try {
      const response = await resetPasswordAPI(token, newPassword);
      if (response.status === 200) {
        setResetMessage('Password reset successfully!');
        setErrorMessage('');
      } else {
        setErrorMessage('Something went wrong. Try again.');
      }
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || 'Server error');
    }
  };

  const getStyle = (isValid) => ({
    color: isValid ? 'green' : 'red',
    fontSize: '14px',
    marginLeft: '10px'
  });

  return (
    <Stack spacing={2} style={{ maxWidth: 400, margin: '0 auto', marginTop: '120px' }}>
      <Typography variant="h6" align="center">Reset Your Password</Typography>

      <TextField
        size="small"
        label="New Password"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <TextField
        size="small"
        label="Confirm Password"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <div style={{ marginLeft: '16px' }}>
        <div className="mb-0 h6" style={{ fontWeight: 'bold', marginTop: "20px" }}>
            Password Rules:
        </div>
        <ul style={{ paddingLeft: 10 }}>
            <li style={getStyle(validation.isLengthy)}>At least 8 characters</li>
            <li style={getStyle(validation.hasUpper)}>At least one uppercase letter</li>
            <li style={getStyle(validation.hasLower)}>At least one lowercase letter</li>
            <li style={getStyle(validation.hasNumber)}>At least one number</li>
            <li style={getStyle(validation.hasSpecialChar)}>At least one special character (!, @, #, $, %, &)</li>
        </ul>
      </div>

      {(resetMessage || errorMessage) && (
        <Typography
          color={resetMessage ? 'success.main' : 'error'}
          align="center"
        >
          {resetMessage || errorMessage}
        </Typography>
      )}

      <Button
        variant="contained"
        onClick={handleReset}
        style={{ maxWidth: 100, textTransform: 'none', fontSize: "16px", alignSelf: 'center', marginBottom: "20px" }}
      >
        Submit
      </Button>
    </Stack>
  );
};

export default ResetPasswordForm;